import { FC, Fragment } from 'react';
import { TableColumn } from 'ui/types/TableColumn';
import styles from './CbLeaderboardTable.module.css';
export interface CbLeaderboardTableProps {
  columns: TableColumn[];
  rowData: any[];
  isMobile?: boolean;
  totalEntries: number;
  isLoading: boolean;
}
export const CbLeaderboardTable: FC<CbLeaderboardTableProps> = ({
  columns = [],
  rowData = [],
  isMobile = false,
  totalEntries,
  isLoading
}) => {
  // Filter out the first three rows if isMobile is true
  if (isMobile) {
    rowData = rowData.slice(2, rowData.length - 1);
  }
  return <div className={`${styles.container} ${isMobile && styles.mobile}`} data-sentry-component="CbLeaderboardTable" data-sentry-source-file="CbLeaderboardTable.tsx">
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr className={styles.tableRow}>
            {columns.map((column, index) => <Fragment key={column.key}>
                <th className={styles.headerCell}>
                  {column.hasCustomTitleElement && column.titleElement ? column.titleElement : column.title}
                </th>
              </Fragment>)}
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          {rowData.map((row, index) => <Fragment key={index}>
              <tr className={`${styles.tableRow} ${row?.isHighlighted && styles.highlightedRow}`}>
                {columns.map((column, index) => <Fragment key={column.key}>
                    <td className={`${styles.dataCell} ${column?.isCentered && styles.centeredCol}`}>
                      {row[column.key]}
                    </td>
                  </Fragment>)}
              </tr>
            </Fragment>)}
        </tbody>
      </table>
    </div>;
};